<template>
  <div class="l-flex-grid l-flex-grid__column">
    <admin-data-table
      item-type="note"
      :fetch-items="fetchSortableNotes"
      #default="{
        customPagination,
        dataTableRows,
        isLoading,
        itemsPerPage,
        onSort,
        searchQueryChanged,
        updateCurrentPage
      }"
    >
      <div class="u-p3">
        <el-data-table
          :data="dataTableRows"
          :loading="isLoading"
          @search-query-changed="searchQueryChanged($event)"
          @search-query-submitted="updateCurrentPage()"
          :items-per-page="itemsPerPage"
          :custom-pagination="customPagination"
          @current-page-updated="updateCurrentPage($event)"
          :use-custom-sort="true"
          @sort="onSort($event)"
          :row-classes="getRowClasses"
          @row-clicked="$emit('row-clicked', $event)"
        >
          <el-data-table-column
            sortable
            :flex-factor="3"
            data-key="title"
            label="Title"
          >
            <template slot-scope="row">
              <span class="u-text--bold">
                {{row.title}}
              </span>
            </template>
          </el-data-table-column>

          <el-data-table-column
            sortable
            :flex-factor="2"
            data-key="reference.reference_label"
            label="Record"
          />

          <el-data-table-column
            sortable
            data-key="creator.name"
            label="Author"
          />

          <el-data-table-column
            sortable
            data-key="date_added"
            label="Date"
          >
            <template slot-scope="row">
              <bc-date-display
                :date="row.date_added"
                format="DD MMM, YYYY"
              >
              </bc-date-display>
            </template>
          </el-data-table-column>
        </el-data-table>
      </div>
    </admin-data-table>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
import notesActions from '#/notes/store/actionTypes'
import notesMutations from '#/notes/store/mutationTypes'
import {AdminDataTable} from '#/notes/components/AdminDataTable'

export default {
  name: 'NotesDataTable',
  components: {
    AdminDataTable
  },
  created () {
    this.resetStore()
  },
  destroyed () {
    this.resetStore()
  },
  computed: {
    ...mapState('notes', [
      'noteTypes'
    ]),
    ...mapGetters('notes', [
      'currentNote'
    ])
  },
  methods: {
    ...mapActions({
      fetchSortableNotes: notesActions.FETCH_SORTABLE_NOTES
    }),
    ...mapMutations({
      resetStore: notesMutations.RESET
    }),
    isRowActive (id) {
      return this.currentNote && this.currentNote.id === id
    },
    getRowClasses ({id}) {
      return ({
        'c-data-table__row--child': this.isRowActive(id)
      })
    }
  }
}
</script>
